module.exports = __webpack_public_path__ + "img/user9.a53e3ac4.jpg";